import Modal from "/WebInterface/new-ui/modules/modal.js";
import { growl, toast } from "/WebInterface/new-ui/modules/toast.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import TwoFactorAuthSetup from "/WebInterface/new-ui/modules/two-factor-auth/two-factor-auth.js";
import {
  confirmQR,
  doLogout,
} from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export const initTwoFactorAuthForceModal = () => {
  const twoFactorAuthSetup = new TwoFactorAuthSetup();

  const twoFactorAuthForceModal = new Modal({
    body: `<div class="px-5" id="twoFactorAuthForceParent"></div>`,
    closable: false,
    hasCloseOption: false,
    uniqueId: "twoAuthForce",
    extraClasses: ["tow-auth-force-modal"],
    minWidth: "700px",
    buttons: [],
  });

  twoFactorAuthSetup.renderTemplate({
    templateContainer: "#twoFactorAuthForceParent",
    templateValues: { showHeader: true },

    onAfterTimeout: () => {
      twoFactorAuthForceModal.update({
        buttons: [],
      });
    },
  });

  twoFactorAuthSetup.addSetupButtonListener(() => {
    const shouldShowQR = window.confirm(t("areYouReadyToScanQR"));
    if (!shouldShowQR) return;
    twoFactorAuthSetup.show();

    twoFactorAuthForceModal.update({
      buttons: [
        {
          label: "confirm",
          classes: ["secondary-button", "mr-3"],
          onClick: async () => {
            try {
              await confirmQR({ qrid: twoFactorAuthSetup.UNIQUE_QR_ID });
              twoFactorAuthForceModal.hide({ OnAfterHide: () => {} });

              toast({
                type: "warning",
                message: t("success"),
                title: t(
                  "twoFactorAuthenticationSetupIsSuccessfulPleaseLoginAgain"
                ),
                autoClose: true,
              });

              setTimeout(() => {
                doLogout();
              }, 3000);
            } catch (error) {
              growl("", error, 5000, true);
            }
          },
        },
      ],
    });
  });
};
